
function Button({type, text, onClick}){
    return (
        <>
            <button type={type} class="btn btn-primary">{text}</button>  
        </>
    );
}

export default Button